import { render, staticRenderFns } from "./foodMaterialType.vue?vue&type=template&id=0e5945f1&scoped=true&"
import script from "./foodMaterialType.vue?vue&type=script&lang=js&"
export * from "./foodMaterialType.vue?vue&type=script&lang=js&"
import style0 from "./foodMaterialType.vue?vue&type=style&index=0&id=0e5945f1&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5945f1",
  null
  
)

component.options.__file = "foodMaterialType.vue"
export default component.exports